export default __webpack_public_path__ + "static/media/civic.bcfaae1f.svg";